import { createContext } from "react";

export type ConfirmModalOptions = {
  question: string;
  onOk: () => void;
};

export type ConfirmModalContextValue = {
  confirm: (options: ConfirmModalOptions) => void;
};

export const ConfirmModalContext = createContext<ConfirmModalContextValue | undefined>(undefined);
